module.exports = __webpack_public_path__ + "img/2013_L.2b43b260.png";